import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { MFEPackageIds } from '@interfaces/open-choice/mfe-details.enum';
import { Store } from '@ngrx/store';
import { sanitizeError } from '@shared/helpers/sanitize-error-helper';
import { LoggerCodes } from '@shared/modules/logger/logger';
import { environment } from '@src/environments';
import * as fromRootStore from '@store/index';
import { from, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MfeLoadService, MfeScriptExistsError } from 'vg-interaction-model';

const MAX_RETRIES = 3;

export const mfeResolver = (mfe: string): ResolveFn<void> => {
  return () => {
    const mfeLoadService: MfeLoadService = inject(MfeLoadService);
    const store: Store<fromRootStore.State> = inject(Store<fromRootStore.State>);
    const mfeUrl = environment.mfe[mfe];
    return from(mfeLoadService.loadMFE(mfe, mfeUrl, MAX_RETRIES)).pipe(
      catchError((error) => {
        if (error instanceof MfeScriptExistsError) {
          return of(undefined);
        }

        store.dispatch(
          fromRootStore.LogError({
            payload: {
              eventId: 'mfe-resolver--mfe-load-error',
              message: `MFE resolver failed to load MFE ${mfe} with error: ${JSON.stringify(sanitizeError(error))}`,
              code: LoggerCodes.NULL_FAILURE,
            },
          }),
        );

        if (mfe === MFEPackageIds.SETTLEMENT_FUND_PKG) {
          store.dispatch(fromRootStore.Next());
          return of(undefined);
        } else if (
          mfe === MFEPackageIds.PORTFOLIO_BUILDER_PKG ||
          mfe === MFEPackageIds.RISK_QUIZ_PKG_ROE
        ) {
          store.dispatch(fromRootStore.rejectDAOffer());
          store.dispatch(fromRootStore.UpdateDAComponentFailure({ payload: true }));
          store.dispatch(fromRootStore.Go({ path: ['secure/minor-transfer/review'] }));
          return of(undefined);
        }
        return of(undefined);
      }),
    );
  };
};
